import { createContext, useEffect, useReducer } from "react";

import axios from "../utils/axios";
import CancelledInvoiceReducer from "../reducers/CancelledInvoiceReducer";
import { isValidToken, setSession } from "../utils/jwt";
import { CancelledInvoiceConstants } from "../constants/cancelledinvoice.constants";
import { saveFile } from "../utils/common";
const initialState = {
  cancelledInvoices: [],
  paging: {
    totalNumberOfRecords: 0,
    totalNumberOfPages: 0,
    pageNumber: 0,
    pageSize: 0,
  },
  hasError: false,
  errorMessage: "",
  smsLogSearchResults: [],
  smsLog: {},
  isUpload: false,
  uploadError: false,
  uploadSuccess: false,
  isSubmitting: false,
  smsLogAutoSearchResults: {
    data: [],
    paging: {
      hasNextPage: false,
      hasPreviousPage: false,
      pageNumber: 0,
      pageSize: 0,
      totalNumberOfPages: 0,
      totalNumberOfRecords: 0,
    },
  },
  isLoadingAutoSearch: false,
};
const initPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

const CancelledInvoiceContext = createContext({
  ...initialState,
  getAllCancelledInvoice: () => {},
  addCancelledInvoice: () => {},
  searchCancelledInvoice: () => {},
  autoSearchCancelledInvoice: () => {},
  getCancelledInvoice: () => {},
  updateCancelledInvoice: () => {},
  downloadFile: () => {},
  sampleFile: () => {},
  uploadFile: () => {},
});

function CancelledInvoiceProvider({ children }) {
  const [state, dispatch] = useReducer(CancelledInvoiceReducer, initialState);

  const getAllCancelledInvoice = async (payload) => {
    try {
      dispatch({
        type: CancelledInvoiceConstants.FETCH_CANCELLEDINVOICE_REQUEST,
      });
      const response = await axios.post("/radius/raduser/cancelled-invoices", payload);
      dispatch({
        type: CancelledInvoiceConstants.FETCH_CANCELLEDINVOICE_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: CancelledInvoiceConstants.FETCH_CANCELLEDINVOICE_FAILURE,
      });
    }
  };
  const searchCancelledInvoice = async (payload) => {
    try {
      const response = await axios.post("/radius/raduser/cancelled-invoices/search", payload);
      dispatch({
        type: CancelledInvoiceConstants.CANCELLEDINVOICE_SEARCH_REQUEST,
      });
      console.log(response.data, "response.data");
      dispatch({
        type: CancelledInvoiceConstants.CANCELLEDINVOICE_SEARCH_SUCCESS,
        payload: response.data,
      });
    } catch (exception) {
      dispatch({
        type: CancelledInvoiceConstants.CANCELLEDINVOICE_SEARCH_FAILURE,
      });
    }
  };
  const autoSearchCancelledInvoice = async (payload) => {
    try {
      const response = await axios.post("/radius/raduser/cancelled-invoices/auto-search", payload);
      dispatch({
        type: CancelledInvoiceConstants.CANCELLEDINVOICE_AUTO_SEARCH_REQUEST,
      });
      console.log(response.data, "response.data");
      dispatch({
        type: CancelledInvoiceConstants.CANCELLEDINVOICE_AUTO_SEARCH_SUCCESS,
        payload: response.data,
      });
    } catch (exception) {
      dispatch({
        type: CancelledInvoiceConstants.CANCELLEDINVOICE_AUTO_SEARCH_FAILURE,
      });
    }
  };

  const getCancelledInvoice = async (id) => {
    const response = await axios.get("/radius/raduser/cancelled-invoices/" + id);
    dispatch({
      type: CancelledInvoiceConstants.GET_CANCELLEDINVOICE_REQUEST,
    });
    dispatch({
      type: CancelledInvoiceConstants.GET_CANCELLEDINVOICE_SUCCESS,
      payload: response.data,
    });
  };

  const downloadFile = async (fileType, payload) => {
    dispatch({
      type: CancelledInvoiceConstants.DOWNLOAD_CANCELLEDINVOICE_REQUEST,
      payload: {
        fileType: fileType,
      },
    });
    const response = await axios.post(
      "/radius/raduser/cancelled-invoices/export/" + fileType,
      payload,
      {
        responseType: "blob",
      },
    );
    console.log(response.headers, "filename");
    //const filename = response.headers.get("content-disposition").split('"');

    await saveFile(response.data, "cancelled-invoice." + fileType);

    dispatch({
      type: CancelledInvoiceConstants.DOWNLOAD_CANCELLEDINVOICE_SUCCESS,
      payload: response.data,
    });
  };

  return (
    <CancelledInvoiceContext.Provider
      value={{
        ...state,
        getAllCancelledInvoice,
        searchCancelledInvoice,
        autoSearchCancelledInvoice,
        getCancelledInvoice,
        downloadFile,
      }}
    >
      {children}
    </CancelledInvoiceContext.Provider>
  );
}

export { CancelledInvoiceContext, CancelledInvoiceProvider };
